export default "__VITE_ASSET__DDMNXSN1__"